export default {
  send: 'Senda',
  forward: 'Áfram',
  OK: 'Staðfesta',
  cancel: 'Hætta við',
  back: 'Til baka',
  addToOrder: 'Setja í körfu',
  updateProduct: 'Uppfæra pöntun',
  chooseOptions: 'Panta',

  user: {
    authenticate: 'Innskráning',
    phoneNumber: 'Símanúmer',
    verificationCode: 'Staðfestingarkóði',
    fullname: 'Nafn á pöntun',
    validation: {
      name: 'Nafn þarf að vera að minnsta kosti 3 stafir',
    },
  },

  checkout: {
    hintPhoneNumber: 'Sláðu inn símanúmer sem getur tekið við SMS. Við munum senda þér kóða til að staðfesta að þú sért handhafi símanúmersins.',
    hintVerificationCode: 'Við höfum sent þér staðfestingarkóða í SMS. Staðfestu símanúmerið þitt með því að slá hann inn.',
    hintFullname: 'Staðfestu að nafnið á pöntuninni sé rétt.',
  },

  catering: {
    title: 'Pantaðu hér',
    amount: 'Fjöldi bakka',
    order: 'Ganga frá pöntuninni',
    deliveryMethod: 'Afhending',
    paymentMethod: 'Hvernig viltu greiða?',
    submit: {
      errors: {
        title: 'Villa',
        message: 'Vinsamlegast athugaðu hvort allt sé útfyllt',
      },
    },
    content: {
      title: 'Veisluþjónusta',
      line1: 'Nú bjóðum við okkar frábæru pítur sem smárétti fyrir öll stór og smá tilefni.',
      line2: 'Mini píturnar eru afgreiddar á hentugum bökkum í nokkrum útfærslum. Á hverjum bakka eru 12 mini pítur. Pantanir eru sóttar í Skipholt 50c.',
      line3: 'Til að leggja inn pöntun getur þú hringt í okkur í síma 562 9090 eða sent okkur póst á: pitan@pitan.is',
      ul: {
        li1: 'Verð á bakka er 4.995 kr.',
        li2: '12 mini pítur á bakka.',
        li3: 'Miðið við 3–4 mini pítur á mann.',
        li4: 'Vinsamlegast pantið tímanlega.',
      },
    },
    form: {
      title: 'Pöntunin þín',
      login: 'Innskráning',
      total: 'Heildarfjöldi pítubakka:',
      trays: 'bakkar',
      totalItems: 'pítur, matur fyrir um {amount} manns',
      price: 'Verð samtals:',
      deliveryDate: 'Hvenær viltu sækja?',
      deliveryTime: 'Klukkan hvað viltu sækja?',
      deliveryLocation: 'Hvar viltu sækja?',
      deliveryInfo: 'Upplýsingar um þig',
      name: 'Nafn *',
      email: 'Netfang *',
      phone: 'Sími *',
      comment: 'Annað sem þú vilt að komi fram',
      submit: 'Klára pöntun',
      errors: {
        name: 'Nafn má ekki vera tómt',
        phone: 'Símanúmer má ekki vera tómt',
      },
    },
  },

  payment: {
    methods: 'Greiðsluleiðir',
    header: 'Greiðsluupplýsingar',
    noDeliveryChosen: 'Veldu hvernig afhending fer fram.',
    phoneNumber: 'Símanúmer',
    cardNumber: 'Kortanúmer',
    expiration: 'Gildistími',
    expirationMonth: 'Mánuður',
    expirationYear: 'Ár',
    ccv: 'Öryggisnúmer',
    cancel: 'Hætta við',
    submitForm: 'Staðfesta greiðsluupplýsingar',
    hintPaymentData: 'Pöntunin verður greidd með korti með númerið ****-****-****-{lastFour}',
    aur: {
      paymentPendingTitle: 'Beðið greiðslu',
      paymentPendingMessage: 'Kláraðu að greiða í gegnum Aur appið til að ljúka pöntun.',
    },
    secure3d: {
      hint: 'Smelltu á “Senda” til að hefja sterka auðkenningu (SCA) á greiðslukortinu.',
      about: 'Hvað er sterk auðkenning (SCA)?',
      submit: 'Senda',
      cancel: 'Hætta við',
    },
    valitorPage: {
      hint: 'Smelltu á “Senda” til að greiða á greiðslusíðu Valitor.',
      submit: 'Senda',
      cancel: 'Hætta við',
      footer: 'Ef þú villt hætta við eða þegar greiðslu er lokið er óhætt að loka greiðslusíðunni til að koma til baka.',
    },
    verifoneCheckout: {
      title: 'Greiða fyrir pöntun',
      hint: 'Til að greiða fyrir pöntunina tekur nú við greiðslusíða hjá Verifone. Eftir að greiðsla berst mun pöntunin fara í vinnslu hjá okkur. Smelltu á “Áfram” til að greiða á greiðslusíðu Verifone.',
      submit: 'Áfram',
      cancel: 'Hætta við',
      footer: 'Ef þú villt hætta við eða þegar greiðslu er lokið er óhætt að loka greiðslusíðunni til að koma til baka.',
    },
    validation: {
      cardNumber: {
        required: 'Það vantar kortanúmer',
        invalid: 'Kortanúmer virðist ógilt',
      },
      ccv: {
        required: 'Það vantar öryggisnúmer',
      },
      expirationMonth: {
        required: 'Það vantar gildistíma',
        invalid: 'Gildistími virðist ógildur',
      },
      expirationYear: {
        required: 'Það vantar gildistíma',
        invalid: 'Gildistími virðist ógildur',
      },
      phoneNumber: {
        required: 'Það vantar símanúmer',
        tooShort: 'Símanúmer er of stutt',
      },
    },
    errorFromPaymentService: 'Greiðsluhirðir gat ekki framkvæmt greiðslu.',
  },

  deliveryMethods: {
    deliveryMethods: 'Afhending',
    noDeliveryMethodAllowed: 'Enginn afhendingarleið í boði. Mögulega er valin staðsetning lokuð.',
  },

  order: {
    header: 'Pöntunin þín',
    thankYou: 'Pöntun er móttekin',
    thankYouDetails: 'Pöntunin þín hefur verið móttekin og verður tilbúin eftir um það bil {wait} mín. Láttu okkur á afgreiðsluborðinu vita þegar þú ert komin(n). Verði þér að góðu!',
    thankYouDetailsOnSite: 'Pöntunin þín hefur verið móttekin og verður tilbúin eftir um það bil {wait} mín. Náðu þér í hnífapör og glas, finndu þér laust sæti. Við köllum svo upp nafnið á pöntuninni þegar hún er tilbúin. Verði þér að góðu!',
    thankYouCateringDetails: 'Pöntun verður framleidd og afhent þann {delivered}',
    isEmpty: 'Þú hefur ekki sett neitt í pöntunina þína. Skoðaðu matseðilinn og bættu við pöntunina.',
    total: 'Heildarupphæð',
    checkout: 'Ganga frá pöntun',
    confirm: 'Staðfesta pöntun',
    productAdded: '{product} bætt við pöntun',
    productUpdated: '{product} breytt',
    removeFromOrder: 'Fjarlægja',
    editProduct: 'Breyta',
    viewMenu: 'Aftur í matseðil',
    coupon: 'Afsláttarkóði',
    customerSsn: 'Kennitala á nótu',
    removeProduct: {
      title: 'Fjarlægja úr pöntun',
      message: '{product} verður fjarlægt úr pöntuninni',
    },
    sendOrder: {
      title: 'Staðfesta pöntun',
      message: 'Eftir að smellt hefur verið á staðfesta er pöntun vistuð og afgreidd.',
    },
  },

  location: {
    openingHours: 'Opið í dag',
    waitingTimes: {
      minutes: 'mínútur',
    },
    closed: 'Í augnablikinu er lokað fyrir pantanir. Vinsamlegast reyndu aftur innan opnunartíma.',
  },

  footer: {
    openingHours: 'Opið alla daga',
  },

  form: {
    months: {
      jan: 'Janúar',
      feb: 'Febrúar',
      mar: 'Mars',
      apr: 'Apríl',
      mai: 'Maí',
      jun: 'Júní',
      jul: 'Júlí',
      aug: 'Ágúst',
      sep: 'September',
      oct: 'Október',
      nov: 'Nóvember',
      dec: 'Desember',
    },
    error: {
      invalidSsn: 'Ógild kennitala',
    },
  },

  email: {
    errors: {
      name: 'Nafn má ekki vera tómt',
      email: 'Netfang má ekki vera tómt',
      message: 'Skilaboð mega ekki vera tóm',
      emailInvalid: 'Netfang er á röngu formi',
    },
  },

  serviceWorker: {
    event: {
      updated: {
        title: 'Ný útgáfa af vefnum er í boði',
        message: 'Þú þarft aðeins að endurhlaða síðuna til að uppfæra.',
        ok: 'Endurhlaða síðuna',
        cancel: 'Ekki núna',
      },
    },
  },

  date: {
    days: ['Sunnudaginn', 'Mánudaginn', 'Þriðjudaginn', 'Miðvikudaginn', 'Fimmtudaginn', 'Föstudaginn', 'Laugardaginn'],
    daysShort: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
    months: ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
  },

  errors: {
    default: {
      title: 'Upp hefur komið villa',
      message: 'Aðgerð skilaði villunni: {error}',
    },
    code: {
      500: {
        title: 'Villa frá vefþjónustu',
        message: 'Vefþjónusta gat ekki framkvæmt aðgerð: "{error}"',
      },
      pilotErrorOrderNotSaved: {
        title: 'Gat ekki vistað pöntun',
        message: '{error}',
      },
      pilotErrorNoData: {
        title: 'Gögn vantar',
        message: 'Pöntun var ekki vistuð. Gögn voru ekki rétt formuð: {error}',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Staðfestingarkóði rangur',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorCouponExpired: {
        title: 'Afsláttarkóði útrunninn',
        message: 'Kóðinn sem þú gafst upp er ekki virkur.',
      },
      pilotErrorCouldNotCreateOrder: {
        title: 'Gat ekki vistað pöntun',
        message: '{error}',
      },
      pilotErrorPaymentProcessError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorCouponNotFound: {
        title: 'Afsláttarkóði finnst ekki',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Kortanúmer ógilt',
        message: 'Athugaðu hvort þú hafir gefið upp rétt númer.',
      },
      pilotErrorExpiredCard: {
        title: 'Gildistími korts er útrunninn',
        message: 'Prófaðu annað kort eða annan greiðslumáta.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Villa í kortanúmeri',
        message: 'Kortanúmer verður að vera 11 til 19 tölustafir',
      },
      pilotErrorOrderNotValid: {
        title: 'Engin pöntun fannst',
        message: 'Það getur gerst ef vöruúrval breytist.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'Við getum ekki afgreitt vöru',
        message: 'Það er vara í pöntuninni sem er ekki í boði fyrir valinn afhendingarmöguleika.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Lágmarksupphæð ekki náð',
        message: 'Til að geta valið þennan afhendingarmáta þarf að panta meira.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er ekki í boði fyrir þennan afhendingarmöguleika.',
      },
      pilotErrorInvalidPinNumber: {
        title: 'Rangt pin númer',
        message: 'Reyndu aftur.',
      },
      couponNeedsDesktop: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður á vefnum.',
      },
      couponNeedsCordova: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður í appi.',
      },
      notAllowed: {
        title: 'Aðgerð ekki framkvæmd',
        message: 'Notandi hefur ekki tilskilin leyfi.',
      },
      ECONNABORTED: {
        title: 'Samskipti runnu út á tíma',
        message: 'Keyrsla tók óeðlilega langan tíma.',
      },
    },
  },
};
